import { bindable } from 'aurelia-framework';

type registrationType = "register-customer" | "activate-token";

export class RegisterOrganization {

    @bindable organizationId = "";
    @bindable organizationName = "";

    orgInfo: { organizationId: string, organizationName: string } = { organizationId: null, organizationName: null };

    registrationType: registrationType | "" = "";
    registrationTypeLabel: string = "";


    bind() {
        console.log('RegisterOrganization.bind');

        this.orgInfo.organizationId = this.organizationId;
        this.orgInfo.organizationName = this.organizationName;
    }

    register(type: registrationType) {
        this.registrationType = type;
        switch(type){
            case "activate-token":
            this.registrationTypeLabel="Register Instance";
            break;
            case "register-customer":
            this.registrationTypeLabel="Register customer";
            break;
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/components/register-organization/register-organization.ts